import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-line-solid",
  "use": "icon-line-solid-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-line-solid\">\n<rect x=\"2\" y=\"8\" width=\"16\" height=\"4\" rx=\"2\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol